import moment from 'moment';

export const getDefaultStartDate = () => moment.utc().subtract(29, 'days').startOf('day').format('X');

export const getDefaultEndDate = () => moment.utc().format('X');

export const today = () => moment.utc(moment.utc(), 'YYYY-MM-DD').format('YYYY-MM-DD');
